import { NavLink } from "react-router-dom";
import { 
  Home, 
  FileText, 
  DollarSign, 
  Receipt, 
  Settings,
  HelpCircle,
  TrendingUp,
} from "lucide-react";

const navigation = [
  { name: "Overview", href: "/athlete/portal", icon: Home },
  { name: "My Deals", href: "/athlete/deals", icon: FileText },
  { name: "Compensation", href: "/athlete/compensation", icon: DollarSign },
  { name: "Tax Dashboard", href: "/athlete/tax-dashboard", icon: Receipt },
  { name: "Marketplace", href: "/athlete/marketplace", icon: TrendingUp },
  { name: "Help & Resources", href: "/athlete/help", icon: HelpCircle },
  { name: "Settings", href: "/athlete/settings", icon: Settings },
];

export function AthleteSidebar() {
  return (
    <div className="flex h-screen w-64 flex-col border-r bg-card">
      <div className="flex h-14 items-center border-b px-4">
        <h2 className="text-lg font-semibold">Athlete Portal</h2>
      </div>
      <nav className="flex-1 space-y-1 overflow-y-auto p-4">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {item.name}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
